import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as FiIconsAll from 'react-icons/fi';
import { FiMessageCircle, FiPackage, FiZap } from 'react-icons/fi';
import WebsiteLayout from '../../../layout/website/WebsiteLayout';
import { getServices } from '../../../../store/services/servicesSlice';
import {
  PageWrapper, Hero, StatsRow,
  SectionTitle, ServicesGrid, ServiceCard,
} from './ServicesStyle';
import { SkeletonServiceCard, NoData } from '../../../shared/WebsiteFeedback';

const getIcon = (name) => {
  if (!name) return <FiPackage />;
  const Icon = FiIconsAll[name];
  return Icon ? <Icon /> : <FiPackage />;
};

const Services = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: servicesData, isLoading } = useSelector(state => state.services);

  useEffect(() => {
    dispatch(getServices({ page: 1, size: 50, query: '', filter: JSON.stringify({ is_active: true }) }));
  }, [dispatch]);

  const services = servicesData?.data || [];

  return (
    <WebsiteLayout>
      <PageWrapper>
        <Hero>
          <div className="hero-label"><FiZap /> {t('website.services.title')}</div>
          <div className="hero-actions">
            <button className="btn-primary"><FiMessageCircle /> {t('website.services.contact_us')}</button>
            <button className="btn-ghost"><FiPackage /> {t('website.services.view_all')}</button>
          </div>
        </Hero>

        <StatsRow>
          <div className="stat-item">
            <div className="stat-icon" style={{ background: 'rgba(147,51,234,0.12)', color: '#a78bfa' }}>
              <FiPackage />
            </div>
            <div className="stat-text">
              <div className="num">{services.length}+</div>
              <div className="lbl">{t('website.services.available_count')}</div>
            </div>
          </div>
        </StatsRow>

        <SectionTitle>
          <div className="s-label">{t('website.services.what_we_offer')}</div>
          <h2>{t('website.services.available_title')} <span>{t('website.services.available_highlight')}</span></h2>
        </SectionTitle>

        {isLoading ? (
          <ServicesGrid>
            {Array.from({ length: 6 }, (_, i) => <SkeletonServiceCard key={i} />)}
          </ServicesGrid>
        ) : services.length === 0 ? (
          <NoData />
        ) : (
          <ServicesGrid>
            {services.map(s => (
              <ServiceCard
                key={s._id}
                glow={s.glow}
                accent={s.accent}
                iconColor={s.icon_color}
                iconBg={s.icon_bg}
                iconBorder={s.icon_bg}
              >
                <div className="card-icon">{getIcon(s.icon_name)}</div>
                <div className="card-title">{s.title}</div>
                <div className="card-desc">{s.description}</div>
                <div className="card-tags">
                  {s.tags?.map(tag => <span className="tag" key={tag}>{tag}</span>)}
                </div>
                <div className="card-cta">
                  {t('website.services.request_service')} <FiIconsAll.FiArrowLeft />
                </div>
              </ServiceCard>
            ))}
          </ServicesGrid>
        )}
      </PageWrapper>
    </WebsiteLayout>
  );
};

export default Services;
